import request from '@/utils/request'
import requestold from '@/utils/requestold'

import { baseUrl } from "@/utils/constant";

//登录接口
export function login(data){
  return request({
    url: '/api/login_check',
    method: 'post',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
    },
    data
  })
}

export function doLogin(params) {
  return requestold({
    url: '/api/contest/login',
    method: 'get',
    params   
  });
}


//中转登录接口 token:rc的token id：rc的用户id
export function transferLogin(params){
return request({
  url: '/api/partner/rc/api/notify',
  method: 'post',
  headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
  },
  params
})
}

export function getInfo(){
  return request({
    url: '/api/my/user/info',
    method: 'get'
  })
}

//退出接口
export function logout(params){
return request({
  url: '/api/logout',
  method: 'get',
  params
})
}

//注册
export function register(data){
  return request({
  url: '/api/register',
  method: 'post',
  data
  })
}


//用户列表  admin_user
export function userList(params){
  return request({
  url: '/api/admin/user',
  method: 'get',
  params
  })
}

//用户列表  admin_user_create
export function createUser(data){
  return request({
  url: '/api/admin/user/create',
  method: 'post',
  data
  })
}

//检查用户邮箱  
export function checkUserEmail(params){
  return request({
  url: '/api/admin/user/create/email/check',
  method: 'get',
  params
  })
}

//检查用户手机
export function checkUserMobile(params){
  return request({
  url: '/api/admin/user/create/mobile/check',
  method: 'get',
  params
  })
}

//检查用户手机
export function checkUserNickname(params){
  return request({
  url: '/api/admin/user/create/nickname/check',
  method: 'get',
  params
  })
}

//修改用户  admin_user_edit
export function editUser(id,data){
  return request({
  url: '/api/admin/user/'+id+'/edit',
  method: 'post',
  data
  })
}

//锁定用户
export function lockUser(id){
  return request({
  url: '/api/admin/user/'+id+'/lock',
  method: 'post'
  })
}
//解锁用户
export function unlockUser(id){
  return request({
  url: '/api/admin/user/'+id+'/unlock',
  method: 'post',
  })
}

//用户信息
export function userInfo(){
  return request({
  url: '/api/user_remind_counter',
  method: 'get'
  })
}


//注册检查邮箱是否重复
export function checkRegisterUserEmail(params){
  return request({
  url: '/api/register/email/check',
  method: 'get',
  params
  })
}

//注册检查用户名是否重复
export function checkRegisterUserNickname(params){
  return request({
  url: '/api/register/nickname/check',
  method: 'get',
  params
  })
}

export function getFooterData(){
  return request({
    url: baseUrl.UC_BASE_URL + '/api/website',
    method: 'get',
  })
}

//切换机构
export function changeOrg(params) {
  return request({
    url: '/api/change_org',
    method: 'get',
    params
  })
}

//创建机构
export function createOrg(params) {
  return request({
    url: '/api/create_org',
    method: 'get',
    params
  })
}

//个人中心
export function toPersonal(params){
  return request({
    url: '/api/to_persoanl',
    method: 'get',
    params
  })
}

//查询用户中心未读消息数量
export function unReadCount(params){
  return request({
    url: baseUrl.UC_BASE_URL + '/api/notification/unReadCount',
    method: 'get',
    params
  })
}